<template>
    <div>
        <view-nav title="Playlist management" @nav="w => this.week = w">
            <template v-if="childRoute === 'Playlists'" v-slot:content="{ emit }">
                <weeks-nav @nav="emit"/>
            </template>
        </view-nav>

        <div class="view-content container-fluid">
            <div class="row">
                <div class="col-2">
                    <ul class="box nav">
                        <li class="nav-item w-100">
                            <router-link to="/playlists" exact-path class="nav-link">
                                <icon name="settings" class="red"></icon> Playlists
                            </router-link>
                        </li>
                        <li class="nav-item w-100">
                            <router-link to="/playlists/pings" exact-path class="nav-link">
                                <icon name="settings" class="red"></icon> Availability pings
                            </router-link>
                        </li>
                        <li class="nav-item w-100">
                            <router-link to="/playlists/confirmations" exact-path class="nav-link">
                                <icon name="settings"></icon> Reception confirmations
                            </router-link>
                        </li>
                    </ul>
                    <div class="box">
                        <div class="box-content">
                            <heading v-if="childRoute === 'Playlists'" upper="Info" border>
                                <template v-slot:lower><span v-html="infoMsg"></span></template>
                            </heading>
                            <heading v-if="childRoute === 'PlaylistAvailablePings'" upper="Help" border>
                                <template v-slot:lower>Availability pings are sent by the playlist provider to notify Showtimes of new playlists to be downloaded.</template>
                            </heading>
                            <heading v-if="childRoute === 'PlaylistConfirmations'" upper="Help" border>
                                <template v-slot:lower>Playlist confirmations are sent by the exhibitor to inform the provider that playlists were well received and (partially) played.</template>
                            </heading>
                        </div>
                    </div>
                </div>
                <div class="col-10">
                    <router-view :week="week" @stats="s => stats = s"></router-view>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import Heading from "../partials/Heading";
import ViewNav from "../partials/ViewNav";
import WeeksNav from "../partials/WeeksNav";

export default {
    components: {
        Heading,
        ViewNav,
        WeeksNav
    },
    asyncData({store}) {
        return store.dispatch('fetchSlices');
    },
    data() {
        return {
            week: null,
            childRoute: this.$route.name,
            stats: {
                totalRows: 0,
                theatre: {}
            },
            infoMsg: '',
        }
    },
    watch: {
        $route(to) {
            this.childRoute = to.name;
        },
        stats(stats) {
            this.setInfoText(this.week, stats);
        },
        week(week) {
            this.setInfoText(week, this.stats);
        }
    },
    methods: {
        setInfoText(week, stats) {
            if (!stats) return this.clearInfoText();

            const
                playlists = stats.totalRows ? this.$tc('plural.playlist', stats.totalRows) : 'No playlists',
                theatre = !stats.theatre.name ? ' in all theatres' : ' in ' + stats.theatre.name;

            this.infoMsg = `${playlists} for ${week.start.format('MMM[&nbsp;]D')} to ${week.end.format('MMM[&nbsp;]D, YYYY')} ${theatre}.`;
        },
        clearInfoText() {
            this.infoMsg = '';
        }
    }
}
</script>
